(function () {

    "use strict";

    angular
        .module('components')
        .component('hBrandsList', {
            controller: HBrandsListComponent,
            controllerAs: '$ctrl',
            bindings: {
                activeBrandId: '<',
                onBrandSelected: '&',
            },
            templateUrl: '../hmodules/components/h-brands-list/h-brands-list.component.html'
        });

    HBrandsListComponent.$inject = ['$scope', '$q', '$element', 'hUser', '$filter', 'userBrandsTreeService', 'userPermissions'];

    function HBrandsListComponent($scope, $q, $element, hUser, $filter, userBrandsTreeService, userPermissions) {
        var self = this;
        self.isLoading = true;
        self.starsLoadingMap = {};
        self.brandsTree;
        self.favouriteBrands;
        self.lockScrollLoad;
        const LOCATION_OPTIONS = {
            ALL: {
                code: 'ALL',
                value: $filter('translate')('All'),
            },
            STARRED: {
                code: 'STARRED',
                value: $filter('translate')('Starred'),
            },
        };
        self.locationTypes = [
          LOCATION_OPTIONS.ALL,
          LOCATION_OPTIONS.STARRED,
        ];
        var originalScrollTopValues = {};


        const init = () => {
            self.isLoading = true;
            userPermissions.getBrandPolicy(hUser.getEntryMode().brand_id).then(function (policyParser) {
                self.hasAccessClosedLocationsPermission = policyParser.has(userPermissions.PERMISSIONS.ACCESS_CLOSED_LOCATIONS);
                loadBrandsTree().then(function () {
                    self.activeLocationType = getActiveLocationType(hUser.getUser().id);
                    setTimeout(function () {
                        $element.find(".locations-search-input input").focus();
                    }, 10);
                });
            })
        };

        self.$onInit = () => {
            init();
        };

        self.assignHandlers = function (element) {
            updateScrollableTopValues(originalScrollTopValues);
            element.find('.brand-item').on('click', function ($event) {
                var $this = $(this);
                var brandId = parseInt($this.attr('data-brand-id'));
                var parentId = parseInt($this.attr('data-parent-id'));
                $(this).find('.brand-radio-btn').first().prop('checked', true);
                $(this).addClass('checked');
                let brandInfo;

                if (self.activeLocationType.code === LOCATION_OPTIONS.ALL.code) {
                    brandInfo = self.brandsTree.find((brand) => {
                        return brand.id === parentId;
                    });
                } else {
                    brandInfo = self.favouriteBrands.find((brand) => {
                        return brand.id === parentId;
                    });
                }


                const brand = brandInfo.brands.find(function (brand) {
                    return brand.id === brandId;
                });

                selectBrand(brand, brandInfo);
            });

            element.find('.toggle-star').on('click', function ($event) {
                var $this = $(this);
                var brandInfoId = parseInt($this.attr('data-parent-id'));
                var brandId = parseInt($this.attr('data-brand-id'));

                var brandInfo = self.brandsTree.find(function (brand) {
                    return brand.id === brandInfoId;
                });

                if (!brandInfo) {
                    brandInfo = self.favouriteBrands.find(function (brand) {
                        return brand.id === brandInfoId;
                    });
                }

                var brand = brandInfo.brands.find(function (brand) {
                    return brand.id === brandId;
                });
                self.toggleStar(brand, $event);
            });
        };

        self.changeActiveLocationType = function (code) {
            self.activeLocationType = LOCATION_OPTIONS[code];
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'brand_selector_list_type_{{id}}',
                value: code,
                variables: {
                    id: hUser.getUser().id
                }
            });
            self.isLoading = true;
            self.filterBrandsList();
        };

        var getOriginalScrollValues = function () {
            var scrollTopValues = {};
            var scrollableAreas = $element.find('.brands-list');
            scrollableAreas.each(function (index, element) {
                scrollTopValues[element.id] = element.scrollTop;
            });
            return scrollTopValues;
        };

        var updateScrollableTopValues = function (scrollTopValues) {
            var scrollableAreas = $element.find('.brands-list');

            scrollableAreas.each(function (index, element) {
                element.scrollTop = scrollTopValues[element.id] || 0;
            });
        };

        self.rerender = function () {
            originalScrollTopValues = getOriginalScrollValues();
            self.viewTrigger = !self.viewTrigger;
            $scope.$digest();
        };

        var ifFavorite = function (arr) {
            for (var x in arr) {
                var brandsFav = arr[x].brands.filter(function (item) {
                    return item.is_favourite === true;
                });
                if (brandsFav.length > 0) {
                    return true;
                }
            }
        };

        const getActiveLocationType = (userId) => {
            const brandSelectorListTypeCache = HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'brand_selector_list_type_{{id}}',
                variables: {
                    id: userId
                }
            });
            let activeLocationType;

            if (brandSelectorListTypeCache) {
                activeLocationType = LOCATION_OPTIONS[brandSelectorListTypeCache];
            } else {
                if (!self.activeLocationType && self.hasFilteredStarredBrands) {
                    activeLocationType = LOCATION_OPTIONS.STARRED;
                } else if (!self.activeLocationType) {
                    activeLocationType = LOCATION_OPTIONS.ALL;
                }
            }

            return activeLocationType;
        };

        var loadBrandsTree = function () {
            const defer = $q.defer();

            userBrandsTreeService.getUserBrandsTree(self.hasAccessClosedLocationsPermission, true)
                .then((brandsTree) => {
                    self.brandsTree = brandsTree;
                    self.filterBrandsList();
                    defer.resolve();
                });

            return defer.promise;
        };

        self.loadMore = function () {
            if (!self.lockScrollLoad && self.activeLocationType === LOCATION_OPTIONS.ALL) {
                self.lockScrollLoad = true;
                self.loadingMore = true;
                var listElement = $element.find('.scroll-list')[0];
                listElement.scrollTop = listElement.scrollHeight - listElement.clientHeight;
                var lastGPIndex = self.brandsTree.length - 1;
                var lastBrandId = self.brandsTree[lastGPIndex].id;
                BrandAPI.getUserBrandsList(userBrandsTreeService.BRAND_LIST_LIMIT, lastBrandId, self.searchTerm, undefined, undefined, self.hasAccessClosedLocationsPermission, true).then((brands) => {
                    if (brands && brands.brands && brands.brands.length) {
                        var key = self.searchTerm || 'ALL';
                        var cachedBrands = userBrandsTreeService.getBrandTreeCache(key);
                        userBrandsTreeService.sortBrandList(key, brands.brands);
                        if (!cachedBrands) {
                            cachedBrands = [];
                        }
                        cachedBrands.push(...brands.brands);
                        userBrandsTreeService.setBrandTreeCache(key, cachedBrands);
                        self.brandsTree = cachedBrands;
                        self.lockScrollLoad = brands.brands.length < userBrandsTreeService.BRAND_LIST_LIMIT;
                    } else {
                        self.lockScrollLoad = true;
                    }
                    self.loadingMore = false;
                    self.rerender();
                });
            }
        };

        const selectBrand = (brand, parentBrand) => {
            self.selectingBrand = true;

            hUser.setUserContext({
                brand_id: parentBrand.id,
                brand_type: "enterprise",
                active_brand_id: brand.id,
                active_brand_type: brand.type,
            })
                .then(() => {
                    self.onBrandSelected({brand: brand})
                        .finally(() => {
                            loadBrandsTree();
                            self.selectingBrand = false;
                        });
                })
                .catch((err) => console.error(err));
        };

        userBrandsTreeService.on(userBrandsTreeService.EVENTS.BRANDS_UPDATED, function (brandId, isFavourite) {
            self.brandsTree.some((brandInfo) => {
                const brand = brandInfo.brands.find((brand) => {
                    return brand.id === brandId;
                });
                if (brand) {
                    brand.is_favourite = isFavourite;
                    return true;
                }
            });

            if (self.activeLocationType.code === LOCATION_OPTIONS.STARRED.code && isFavourite === false) {
                self.favouriteBrands.some((brandInfo) => {
                    const brandIndex = brandInfo.brands.findIndex((brand) => {
                        return brand.id === brandId;
                    });
                    if (brandIndex > -1) {
                        brandInfo.brands.splice(brandIndex, 1);
                        self.hasFilteredStarredBrands = ifFavorite(self.favouriteBrands);
                        return true;
                    }
                });
            }
            self.rerender();
        });

        self.toggleStar = function (brand, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            if (!self.starsLoadingMap[brand.id]) {
                self.starsLoadingMap[brand.id] = true;
                self.rerender();
                var method;
                if (brand.is_favourite) {
                    method = BrandAPI.unstarBrand;
                } else {
                    method = BrandAPI.starBrand;
                }
                method(brand.id).then(function () {
                    userBrandsTreeService.updateBrandStarStatus(brand.id, !brand.is_favourite);
                    self.starsLoadingMap[brand.id] = false;
                    var msg = "";
                    if (!brand.is_favourite) {
                        msg = $filter('translate')("Added") + " " + brand.name + " " + $filter('translate')("to Starred");
                    } else {
                        msg = $filter('translate')("Removed") + " " + brand.name + " " + $filter('translate')("from Starred");
                    }
                    HNotifications.show({
                        title: $filter('translate')("Success"),
                        desc: msg,
                        icon: "fa-check-circle",
                        type: "success"
                    });
                }).catch(function (err) {
                    console.error(err);
                    HNotifications.show({
                        title: $filter('translate')("Something went wrong") + "!",
                        desc: $filter('translate')("Please try again") + "!",
                        icon: "fa-times",
                        type: "danger",
                        timeout: 3000
                    });
                }).finally(function () {
                    $scope.$evalAsync();
                });
            }
        };

        var resetSourceAndHireView = function () {
            self.brandsTree = angular.copy(userBrandsTreeService.getBrandTreeCache('ALL'));
            self.lockScrollLoad = self.brandsTree.length < userBrandsTreeService.BRAND_LIST_LIMIT;
            userBrandsTreeService.getUserFavouriteBrandsTree()
                .then((favBrands) => {
                    self.favouriteBrands = favBrands;
                    if (userBrandsTreeService.getFavouriteBrandsFlatData().length) {
                        self.hasFilteredStarredBrands = true;
                    }
                    self.hasFilteredLocations = true;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        };

        const filterFavouriteBrands = (searchTerm, favouriteBrands) => {
            const filteredBrands = [];

            for (let brandInfo of favouriteBrands) {
                const brands = brandInfo.brands.filter((item) => {
                    return item.name.toLowerCase().indexOf(searchTerm) > -1;
                });
                filteredBrands.push({...brandInfo, brands: brands});
            }

            return filteredBrands;
        };

        self.filterBrandsList = function () {
            const searchTerm = (self.searchTerm || '').toLowerCase();
            self.hasFilteredLocations = false;
            self.hasFilteredStarredBrands = false;

            if (searchTerm) {
                self.lockScrollLoad = true;
                if (self.activeLocationType === LOCATION_OPTIONS.STARRED) {
                    userBrandsTreeService.getUserFavouriteBrandsTree().then(function (favBrands) {
                        self.favouriteBrands = filterFavouriteBrands(searchTerm, favBrands);
                        for (let i in self.favouriteBrands) {
                            if (self.favouriteBrands[i].brands.length > 0) {
                                self.hasFilteredLocations = true;
                                self.hasFilteredStarredBrands = true;
                                break;
                            }
                        }
                        self.isLoading = false;
                    });
                } else {
                    self.isLoading = true;

                    setTimeout(function () {
                        if (self.searchTerm && searchTerm === self.searchTerm.toLowerCase() && self.activeLocationType === LOCATION_OPTIONS.ALL) {
                            userBrandsTreeService.searchUserBrandsTree(self.searchTerm, self.hasAccessClosedLocationsPermission, true).then((brands) => {
                                if (self.searchTerm && searchTerm === self.searchTerm.toLowerCase() && self.activeLocationType === LOCATION_OPTIONS.ALL) {
                                    if (brands.brands.length) {
                                        self.brandsTree = brands.fromCache ? brands.brands : userBrandsTreeService.sortBrandList(self.searchTerm, brands.brands);

                                        for (let x in self.brandsTree) {
                                            if (self.brandsTree[x].brands.length > 0) {
                                                self.hasFilteredLocations = true;

                                                if (ifFavorite(self.brandsTree)) {
                                                    self.hasFilteredStarredBrands = true;
                                                }
                                            }
                                        }
                                        self.lockScrollLoad = brands.brands.length < userBrandsTreeService.BRAND_LIST_LIMIT;
                                    } else {
                                        userBrandsTreeService.sortBrandList(self.searchTerm, []);
                                        self.brandsTree = [];
                                        self.hasFilteredLocations = false;
                                    }
                                    self.isLoading = false;
                                }
                            });
                        } else if (!self.searchTerm) {
                            resetSourceAndHireView();
                            self.rerender();
                        }
                    }, 300);
                }
            } else {
                resetSourceAndHireView();
            }
        };

        self.clearSearch = function () {
            self.searchTerm = null;
            self.filterBrandsList();
        };

        self.$onDestroy = function () {
            userBrandsTreeService.clearSearchCache();
        };
    }
})();
